<template>
    <lay-row space="10">
      <lay-col md="24">
        <lay-panel>
          <lay-form :model="search" style="text-align: start" size="sm" >

            <lay-form-item label="代理账号" prop="username" mode="inline"   v-if="allAgentNameArr.length!=0">
              <lay-select v-model="search.key" :show-search="true" :multiple="false">
                <lay-select-option  v-for="agent in allAgentNameArr" :key="agent.userId" :value="agent.userId" :label="agent.userName"></lay-select-option>
                 
              </lay-select>
            </lay-form-item>

             <lay-form-item label="搜索" prop="key" mode="inline" >
                <lay-input placeholder="请输入ip/访问"  v-model="search.searchKey"></lay-input>
             </lay-form-item>


              <lay-form-item label="日期范围"  mode="inline">
              <lay-date-picker  v-model="search.rangeTime" range type="datetime" :placeholder="['开始日期','结束日期']"></lay-date-picker>
            </lay-form-item>

    
            <lay-form-item >
              <lay-button type="primary" size="sm" @click="searchUser">查询</lay-button>
            </lay-form-item> 
          </lay-form> 

          <lay-table :page="page" :height="'100%'" :columns="columns" :loading="loading" :data-source="dataSource"
            v-model:selected-keys="selectedKeys" @change="change" @sortChange="sortChange">  
             
          </lay-table> 
        </lay-panel>
  
      </lay-col>
  
    </lay-row>
 
  </template>
  
  <script lang="ts" setup>
  import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allImgLog,allAgentName} from '../../api'
  
 
   const allAgentNameArr=ref([]);
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);

  
  const page = reactive({ current: 1, limit: 10, total: 0 });

  const search = reactive({
     key:"", 
    rangeTime:[],
    searchKey:""
  })
  
  const columns = ref([
    { title: "id", key: "id", align: "center" },
     { title: "代理", key: "userId", align: "center"},   
    { title: "访问地址", key: "source", align: "center"},
    { title: "ip", key: "ip", align: "center"},   
    { title: "请求头", key: "userAgent", align: "center"}, 
    { title: "时间", key: "addTime", align: "center" }, 
  ]);
  
  const getAllAdminUser = () => {
    loading.value = true;
 
      var data = { "page": page.current, "limit": page.limit, "key": search.key, "startTime":search.rangeTime[0],"endTime":search.rangeTime[1],"searchKey":search.searchKey};
   
    allImgLog(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllAdminUser();
  
  const change = (page: any) => {
    getAllAdminUser();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
   
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllAdminUser();
  }
 


   const allAgentNameList=()=>{
   
    allAgentName().then((res: any) => {
    
      if (res != "" && res.code == 0) {
        allAgentNameArr.value = res.data;
      
      } else {
        allAgentNameArr.value=[];
      }
    })

  }
  allAgentNameList();

  </script>
  
  <style scoped>
  </style>